export default __webpack_public_path__ + "static/media/diceProcess.9e64c09e.png";